export const facilitators = [
  {
    slug: 'border-health-connect',
    name: 'Border Health Connect',
    country: 'Mexico',
    city: 'Tijuana',
    services: ['Airport Shuttle', 'Short Term Rental', 'Bilingual Guide'],
    totalPackagePrice: 'From $500 (Logistics only)',
    description:
      'Specializing in cross-border logistics for patients traveling from Southern California to Tijuana. They provide seamless transportation, bilingual escorts, and comfortable recovery accommodations.',
    image:
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'cancun-medical-travel',
    name: 'Cancun Medical Travel',
    country: 'Mexico',
    city: 'Cancun',
    services: ['Travel Planning', 'Meals (All diets)', 'Post-op Nursing'],
    totalPackagePrice: 'From $1,200 (Logistics + Nursing)',
    description:
      'A premium concierge service in Cancun that handles everything from flight bookings to 24/7 post-operative nursing care in luxury beachfront recovery retreats.',
    image:
      'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'siam-medical-concierge',
    name: 'Siam Medical Concierge',
    country: 'Thailand',
    city: 'Bangkok',
    services: [
      'Visa Assistance',
      'Luxury Transport',
      'Translation',
      'Meals (Halal/Veg)',
    ],
    totalPackagePrice: 'From $800 (Logistics only)',
    description:
      'Offering VIP treatment for medical tourists in Thailand. Their services include fast-track immigration, luxury limousine transfers, and dedicated medical translators for all major languages.',
    image:
      'https://images.unsplash.com/photo-1542314831-c6a4d14d8c53?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'istanbul-health-travel',
    name: 'Istanbul Health Travel',
    country: 'Turkey',
    city: 'Istanbul',
    services: [
      'Airport Shuttle',
      'VIP Hotel Booking',
      'Translation',
      'City Tours',
    ],
    totalPackagePrice: 'Often included in procedure price',
    description:
      'A comprehensive agency that often partners directly with clinics to provide all-inclusive packages, combining medical treatments with luxury hotel stays and cultural tours of Istanbul.',
    image:
      'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?q=80&w=2938&auto=format&fit=crop',
  },
  {
    slug: 'cureindia-concierge',
    name: 'CureIndia Concierge',
    country: 'India',
    city: 'New Delhi',
    services: [
      'Medical Visa Assistance',
      'Airport Shuttle',
      'Meals (Veg/Jain)',
      'Local SIM Card',
    ],
    totalPackagePrice: 'From $400 (Logistics only)',
    description:
      'Dedicated to making the complex journey to India simple. They assist with the stringent medical visa process, provide local communication tools, and cater to highly specific dietary requirements.',
    image:
      'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?q=80&w=2942&auto=format&fit=crop',
  },
  {
    slug: 'pura-vida-medical-travel',
    name: 'Pura Vida Medical Travel',
    country: 'Costa Rica',
    city: 'San José',
    services: ['Recovery Retreat Booking', 'Airport Shuttle', 'Nursing Care'],
    totalPackagePrice: 'From $1,500 (Retreat + Nursing)',
    description:
      'Focuses on the holistic recovery experience, placing patients in serene, nature-surrounded recovery retreats with attentive nursing staff following their procedures in San José.',
    image:
      'https://images.unsplash.com/photo-1552640227-7406bf6e3c2f?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'iberia-health-services',
    name: 'Iberia Health Services',
    country: 'Spain',
    city: 'Madrid',
    services: ['Translation', 'Accommodation Booking', 'Travel Planning'],
    totalPackagePrice: 'From $600 (Logistics only)',
    description:
      'Provides high-end logistical support for patients traveling to Spain, ensuring seamless communication with medical staff and comfortable stays in premium accommodations.',
    image:
      'https://images.unsplash.com/photo-1543783207-ec64e4d95325?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'budapest-medical-travel',
    name: 'Budapest Medical Travel',
    country: 'Hungary',
    city: 'Budapest',
    services: ['Airport Shuttle', 'Hotel Booking', 'Translation'],
    totalPackagePrice: 'Often included in dental packages',
    description:
      'Specializing primarily in dental tourism, they coordinate flights, transfers, and accommodations, often bundling these services directly with the dental treatment plans.',
    image:
      'https://images.unsplash.com/photo-1514896856000-91cb6de818e0?q=80&w=2942&auto=format&fit=crop',
  },
  {
    slug: 'dubai-medical-concierge',
    name: 'Dubai Medical Concierge',
    country: 'United Arab Emirates',
    city: 'Dubai',
    services: [
      'Golden Visa Assistance',
      'Property Investment Consulting',
      '24/7 Nursing Care',
      'Luxury Transport',
    ],
    totalPackagePrice: 'From $10,000 (Consulting & Logistics)',
    description:
      'An ultra-luxury service catering to high-net-worth individuals seeking long-term medical settlement in the UAE. They assist with Golden Visa applications, real estate, and securing 24/7 private nursing.',
    image:
      'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2940&auto=format&fit=crop',
  },
]
